"use client";

import { motion, useReducedMotion } from "framer-motion";

interface Props {
	className?: string;
	/** Distance to reveal, in pixels (default full width of container). */
	width?: string;
	/** Reveal duration in seconds. */
	duration?: number;
}

const Speedline = ({ className = "", width = "6rem", duration = 0.6 }: Props) => {
	const shouldReduceMotion = useReducedMotion();

	return (
		<motion.div
			className={`h-[2px] bg-gradient-to-r from-brand via-brand/50 to-transparent ${className}`}
			style={{ width, transformOrigin: "left center" }}
			initial={shouldReduceMotion ? { scaleX: 1 } : { scaleX: 0 }}
			whileInView={{ scaleX: 1 }}
			viewport={{ once: true, margin: "0px 0px -10% 0px" }}
			transition={{ duration: shouldReduceMotion ? 0 : duration, ease: [0.17, 0.55, 0.55, 1] }}
		/>
	);
};

export default Speedline;
